function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Row, Col, Button, ColorBatch, CreditDetailsTab, CreditBorrowerTab, CreditDocumentsTab, CreditPaymentsTab, CreditHistoryTab, CreditActionsTab, useUser } from 'components';
import { showApiError, convertToAdditionalCurrency, canEnterPayment } from 'utils';
import { getCredit, getCreditRefinanceAmount } from 'services';
import { CREDIT_STATUS, creditsStatusName, creditStatusColorMap, CREDIT_PAYMENT_TYPE, ROLES } from 'enums';
import { headerLeftTitle, headerLeftSubTitle, headerLeftId } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var active = CREDIT_STATUS.active,
    delayed = CREDIT_STATUS.delayed,
    approved = CREDIT_STATUS.approved;

var CreditDetails = function CreditDetails(_ref) {
  var _location$state, _match$params, _creditData$borrower2, _creditData$borrower3, _creditData$borrower4, _creditData$borrower5;

  var location = _ref.location,
      match = _ref.match,
      history = _ref.history;

  var _ref2 = (_location$state = location.state) !== null && _location$state !== void 0 ? _location$state : {},
      credit = _ref2.credit;

  var _ref3 = (_match$params = match.params) !== null && _match$params !== void 0 ? _match$params : {},
      creditId = _ref3.creditId;

  var _useState = useState(credit),
      _useState2 = _slicedToArray(_useState, 2),
      creditData = _useState2[0],
      setCreditData = _useState2[1];

  var _useUser = useUser(),
      userInfo = _useUser.userInfo;

  var isSeparatePayment = (creditData === null || creditData === void 0 ? void 0 : creditData.credit_payment_type) === CREDIT_PAYMENT_TYPE.home_visit_fee_separate_payment;
  var isActiveOrDelayed = (creditData === null || creditData === void 0 ? void 0 : creditData.status) === active || (creditData === null || creditData === void 0 ? void 0 : creditData.status) === delayed;
  var isPartnerOrPartnerManager = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.user_role) === ROLES.partner || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.user_role) === ROLES.partner_manager;
  var showSubStatus = (creditData === null || creditData === void 0 ? void 0 : creditData.status) === approved && isSeparatePayment && !!(creditData !== null && creditData !== void 0 && creditData.documents_after_approval_signed);
  var showEarlyRepaymentRequest = isActiveOrDelayed && isSeparatePayment && !isPartnerOrPartnerManager;
  var showFullRepayment = isActiveOrDelayed && (!isSeparatePayment || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.user_role) === ROLES.partner);
  var showRefinance = isActiveOrDelayed && !isPartnerOrPartnerManager;
  useEffect(function () {
    fetchCreditData();
  }, [creditId]);

  var fetchCreditData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getCredit, _yield$getCredit2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getCredit(creditId);

            case 2:
              _yield$getCredit = _context.sent;
              _yield$getCredit2 = _slicedToArray(_yield$getCredit, 2);
              res = _yield$getCredit2[0];
              err = _yield$getCredit2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setCreditData(function (prev) {
                return _objectSpread(_objectSpread({}, prev), res);
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchCreditData() {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleRefinanceCredit = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _creditData$borrower;

      var _yield$getCreditRefin, _yield$getCreditRefin2, res, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getCreditRefinanceAmount(creditId);

            case 2:
              _yield$getCreditRefin = _context2.sent;
              _yield$getCreditRefin2 = _slicedToArray(_yield$getCreditRefin, 2);
              res = _yield$getCreditRefin2[0];
              err = _yield$getCreditRefin2[1];

              if (!err) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 8:
              history.push({
                pathname: '/credits/new',
                state: {
                  borrowerIdNumber: creditData === null || creditData === void 0 ? void 0 : (_creditData$borrower = creditData.borrower) === null || _creditData$borrower === void 0 ? void 0 : _creditData$borrower.id_number,
                  refinanceData: _objectSpread(_objectSpread({}, res), {}, {
                    creditId: creditId
                  })
                }
              });

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleRefinanceCredit() {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleEarlyRepaymentRequest = function handleEarlyRepaymentRequest() {
    history.push({
      pathname: "/credits/early-repayment-request/".concat(creditId),
      state: {
        credit: creditData
      }
    });
  };

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white",
    padding: "2em",
    margin: "0 2em"
  }, ___EmotionJSX(Col, {
    sm: "auto",
    margin: "0 0 1.4em"
  }, ___EmotionJSX("h6", {
    css: headerLeftTitle
  }, "\u041D\u043E\u043C\u0435\u0440: ", creditData === null || creditData === void 0 ? void 0 : creditData.number), ___EmotionJSX("h6", {
    css: headerLeftSubTitle
  }, "\u0421\u0443\u043C\u0430: ", creditData === null || creditData === void 0 ? void 0 : creditData.amount, " ", creditData === null || creditData === void 0 ? void 0 : creditData.currency, " /", convertToAdditionalCurrency({
    value: creditData === null || creditData === void 0 ? void 0 : creditData.amount,
    fromCurrency: creditData === null || creditData === void 0 ? void 0 : creditData.currency
  })), ___EmotionJSX("div", {
    css: headerLeftId
  }, ___EmotionJSX("span", null, creditData === null || creditData === void 0 ? void 0 : (_creditData$borrower2 = creditData.borrower) === null || _creditData$borrower2 === void 0 ? void 0 : _creditData$borrower2.first_name, " ", creditData === null || creditData === void 0 ? void 0 : (_creditData$borrower3 = creditData.borrower) === null || _creditData$borrower3 === void 0 ? void 0 : _creditData$borrower3.middle_name, " ", creditData === null || creditData === void 0 ? void 0 : (_creditData$borrower4 = creditData.borrower) === null || _creditData$borrower4 === void 0 ? void 0 : _creditData$borrower4.last_name), ___EmotionJSX(ColorBatch, {
    type: creditStatusColorMap[creditData === null || creditData === void 0 ? void 0 : creditData.status],
    fontSize: "1rem",
    margin: "0 0 0 6px"
  }, creditsStatusName[creditData === null || creditData === void 0 ? void 0 : creditData.status]), showSubStatus && ___EmotionJSX(ColorBatch, {
    type: creditData !== null && creditData !== void 0 && creditData.partner_documents_signed ? 'info' : 'warning',
    fontSize: "1rem",
    margin: "0 0 0 6px"
  }, creditData !== null && creditData !== void 0 && creditData.partner_documents_signed ? 'Чака изплащане' : 'Чака подписване на договор за ДП'))), ___EmotionJSX(Col, {
    sm: "auto",
    displayFlex: true,
    margin: "0 0 1.4em"
  }, ___EmotionJSX(Row, {
    horizontalGap: 8
  }, canEnterPayment(creditData, userInfo) && ___EmotionJSX(Col, {
    sm: "auto"
  }, ___EmotionJSX(Button, {
    small: true,
    type: "primary",
    linkTo: {
      pathname: "/credits/payment/".concat(creditId),
      state: {
        credit: creditData
      }
    },
    leftIcon: {
      iconName: 'la la-coins',
      size: 18
    }
  }, "\u0412\u044A\u0432\u0435\u0434\u0438 \u0432\u043D\u043E\u0441\u043A\u0430")), showEarlyRepaymentRequest && ___EmotionJSX(Col, {
    sm: "auto"
  }, ___EmotionJSX(Button, {
    small: true,
    type: "danger",
    onClick: handleEarlyRepaymentRequest,
    leftIcon: {
      iconName: 'la la-file-invoice',
      size: 18
    }
  }, "\u041F\u0440\u0435\u0434\u0441\u0440\u043E\u0447\u043D\u043E \u043F\u043E\u0433\u0430\u0441\u044F\u0432\u0430\u043D\u0435")), showFullRepayment && ___EmotionJSX(Col, {
    sm: "auto"
  }, ___EmotionJSX(Button, {
    small: true,
    type: "warning",
    linkTo: {
      pathname: "/credits/payment/".concat(creditId),
      search: '?full_early_repayment=true',
      state: {
        credit: creditData
      }
    },
    leftIcon: {
      iconName: 'la la-check-circle',
      size: 18
    }
  }, "\u041F\u043E\u0433\u0430\u0441\u0438")), showRefinance && ___EmotionJSX(Col, {
    sm: "auto"
  }, ___EmotionJSX(Button, {
    small: true,
    type: "success",
    onClick: handleRefinanceCredit,
    leftIcon: {
      iconName: 'la la-sync',
      size: 18
    }
  }, "\u0420\u0435\u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u0430\u0439")), ___EmotionJSX(Col, {
    sm: "auto"
  }, ___EmotionJSX(Button, {
    small: true,
    type: "info",
    linkTo: {
      pathname: "/borrowers/details/".concat(creditData === null || creditData === void 0 ? void 0 : (_creditData$borrower5 = creditData.borrower) === null || _creditData$borrower5 === void 0 ? void 0 : _creditData$borrower5.id_number),
      state: {
        borrower: creditData === null || creditData === void 0 ? void 0 : creditData.borrower
      }
    },
    leftIcon: {
      iconName: 'la la-user',
      size: 18
    }
  }, "\u0414\u0435\u0442\u0430\u0439\u043B\u0438 \u043A\u0440\u0435\u0434\u0438\u0442\u043E\u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B"))))), ___EmotionJSX(Tabs, {
    startingRoute: match.url,
    noAnimation: true,
    padding: "0 2em"
  }, ___EmotionJSX(Tab, {
    url: "/details",
    component: function component(data) {
      return ___EmotionJSX(CreditDetailsTab, _extends({}, data, {
        credit: creditData
      }));
    },
    label: "\u0414\u0435\u0442\u0430\u0439\u043B\u0438"
  }), ___EmotionJSX(Tab, {
    url: "/borrower",
    component: function component(data) {
      return ___EmotionJSX(CreditBorrowerTab, _extends({}, data, {
        borrower: creditData === null || creditData === void 0 ? void 0 : creditData.borrower
      }));
    },
    label: "\u041A\u0440\u0435\u0434\u0438\u0442\u043E\u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B"
  }), ___EmotionJSX(Tab, {
    url: "/documents",
    component: function component(data) {
      return ___EmotionJSX(CreditDocumentsTab, _extends({}, data, {
        creditId: Number(creditId),
        data: creditData,
        onCreditStatusChange: function onCreditStatusChange(data) {
          return setCreditData(function (prev) {
            return _objectSpread(_objectSpread({}, prev), data);
          });
        }
      }));
    },
    label: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438"
  }), ___EmotionJSX(Tab, {
    url: "/payments",
    component: function component(data) {
      return ___EmotionJSX(CreditPaymentsTab, _extends({}, data, {
        creditId: Number(creditId),
        creditPaymentType: creditData === null || creditData === void 0 ? void 0 : creditData.credit_payment_type,
        onCreditChange: fetchCreditData
      }));
    },
    label: "\u0412\u043D\u043E\u0441\u043A\u0438"
  }), ___EmotionJSX(Tab, {
    url: "/history",
    component: function component(data) {
      return ___EmotionJSX(CreditHistoryTab, _extends({}, data, {
        history: creditData === null || creditData === void 0 ? void 0 : creditData.history
      }));
    },
    label: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F"
  }), ___EmotionJSX(Tab, {
    url: "/actions",
    component: function component(data) {
      return ___EmotionJSX(CreditActionsTab, _extends({}, data, {
        creditId: Number(creditId)
      }));
    },
    label: "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F"
  })));
};

CreditDetails.propTypes = {
  location: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object
};
export default CreditDetails;